jQuery(function () {
    var defaultDelay = 250;

    window.pixelpoint =  window.pixelpoint || {};
    window.pixelpoint.map =  window.pixelpoint.map || {};
    window.pixelpoint.map.promises =  window.pixelpoint.map.promises || {};
    window.pixelpoint.map.promises.airBnBMapLoaded = window.pixelpoint.map.promises.airBnBMapLoaded || $.Deferred();

    window.ppComponents = window.ppComponents || {};
    window.ppComponents.select2 = window.ppComponents.select2 || {};

    window.ppComponents.select2.initializeRemote = function (elements) {
        elements.each(function () {
            var $this = $(this);

            // Avoid binding Select2 remote logic multiple times on the same element.
            if ($this.hasClass('select2-hidden-accessible')) {
                return;
            }

            var remoteUrl = $this.data("src");
            var asArray = $this.data("as-array");
            var useNameInValue = $this.is("[data-name-in-value]");
            var useExternalIdInValue = $this.is("[data-external-id-in-value]");
            var appendToValue = $this.data("append-to-value");
            var cssClass = $this.data("dropdown-css-class") || "";
            var containerCssClass = $this.data("container-css-class") || "";
            //var enableResizableText = $this.is("[data-resizable-text]");
            var allowClear = $this.data('allow-clear') || false;
            var alternativeUrl = $this.data('alternative-src') || false;
            var useAlternative = false;
            var useAlternativeWhenNotIn = $this.data('use-alternative-when') || false;
            var useCustomTransportFunction = (!!$this.data('custom-transport-function')) || false;
            var customTransportFunction = $this.data('custom-transport-function') || null;

            var lang = "de";
            var langObject = $("[data-language-obj]").data("language-obj");
            if(!!langObject){
                lang = langObject.code;
            }

            let addCssContainerClass = ($this) => {
                if(!!containerCssClass) {
                    $this.data('select2').$dropdown.addClass(containerCssClass);
                }
            };

            var closeOnSelect = true;  
            if($this.data('close-select') == 'disabled' ){ 
                closeOnSelect = false; 
            } 

            var closestForm = $(this).closest("form");

            var isLocationTree = $this.hasClass('locationTree');
            var supressLocationTreeFilter = $this.is('[data-supress-location-tree-filter]');

            if (isLocationTree && $this.is('[multiple]')) {
                // we add the location button
                $this.parent().addClass("withGeolocation");

                var onTargetClick = function () {
                    window.pixelpoint.geoTool.geocode().done(function (data) {
                        if ($this.hasClass('select2-hidden-accessible')) {
                            if (!!data && !!data.locations && !!data.locations[0]) {
                                $this.html(`<option value="${data.locations[0].id}:${data.locations[0].name}:location" selected>${data.locations[0].name}</option>`);
                                $this.select2('data', {
                                    id: `${data.locations[0].id}:${data.locations[0].name}:location`,
                                    text: data.locations[0].name,
                                })
                                $this.trigger('change');
                                window.pixelpoint.pubSub.publish(window.pixelpoint.pubSub.events.airBnBSearch, {});
                            } else {
                                window.pixelpoint.modal.open(window.ppt.translate("geolocation.error", "Leider konnte Ihre Position nicht ermittelt werden. Bitte wählen Sie ihren Ort manuell aus."), window.ppt.translate("geolocation.error.title", "Fehler beim ermitteln Ihes Ortes!"));
                            }
                        }
                    }).fail(function(){
                        window.pixelpoint.modal.open(window.ppt.translate("geolocation.error", "Leider konnte Ihre Position nicht ermittelt werden. Bitte wählen Sie ihren Ort manuell aus."), window.ppt.translate("geolocation.error.title", "Fehler beim ermitteln Ihes Ortes!"));
                    });
                };
                var searchAroundTranslation = window.ppt.translate("geolocation.search.area", "In der Umgebung suchen");
                var icon = $(`<i class="icon-target" title="${searchAroundTranslation}"></i>`).insertAfter($this).on("click", function (e) {
                    onTargetClick();
                });
                window.pixelpoint.tooltip.init(icon);

                //var map = window.pixelpoint.airBnB.mapObject();

                window.pixelpoint.map.promises.airBnBMapLoaded.then(map => {
                    if (map != null) {
                        map.$on("geoSearch", function () {
                            onTargetClick();
                        });
                    }
                });

            }

            if (!window.ppComponents.select2.customTransportFunctions)
                window.ppComponents.select2.customTransportFunctions = {};
            if (!window.ppComponents.select2.customTransportFunctions.form) {
                window.ppComponents.select2.customTransportFunctions.form = function (params, success, failure) {
                    var form = closestForm;

                    if (form.length == 0)
                        failure();

                    var data = form.serialize();

                    $.ajax({
                        url: params.url,
                        type: "POST",
                        data: data,
                        success: success,
                        error: failure
                    });
                }
            }

            $this.off("select2:select").on("select2:select", function (e) {
                // not used
                /*if (enableResizableText) {
                    var selectionWrapper = $this.parent().find(".selection");
                    var rendered = selectionWrapper.find(".select2-selection__rendered");
                    rendered.css("font-size", "");
                    var parentWidth = selectionWrapper.width(),
                        parentHeight = selectionWrapper.height(),
                        width = rendered.width(),
                        height = rendered.height();
                    var computedStyle = window.getComputedStyle($this[0]);
                    var fontsize = computedStyle.getPropertyValue('font-size');
                    fontsize = parseFloat(fontsize);
                    while (width > (parentWidth - 25) || height > parentHeight) {
                        fontsize *= 0.95;
                        rendered.css("font-size", fontsize + "px");
                        width = rendered.width();
                        height = rendered.height();
                    }
                }*/

                if(!closeOnSelect && isLocationTree && !supressLocationTreeFilter){
                    $this.data('select2').trigger('query');
                }
            });

            if (window.pixelpoint.utilities.isTouchDevice()) {
                $this.off("select2:open").on("select2:open", function () {
                    var searchField = $('.select2-container.select2-container--open').find('.select2-search__field');
                    var parent = searchField.closest(".select2-selection");
                    setTimeout(() => {
                        if (!searchField.val())
                            searchField.blur().off("click").on("click", function (e) {});
                    }, 10);
                    addCssContainerClass($this);
                });
            }

            if (!remoteUrl) {
                $this.select2({
                    closeOnSelect:closeOnSelect,
                    language:lang
                });
                return;
            }

            var getUrl = function () {
                if (useAlternative)
                    return alternativeUrl;
                return remoteUrl;
            }

            if (isLocationTree && !supressLocationTreeFilter) {

                var spaceUnits = ["region", "aqua", "national", "excursion", "location"];

                getUrl = function () {
                    var url = remoteUrl;
                    if (useAlternative)
                        url = alternativeUrl;
                    var currentValues = $this.val();
                    if (!!currentValues) {
                        if (currentValues.constructor == Array) {
                            $.each(currentValues, function (index, currentValue) {
                                var parameters = currentValue.split(":");
                                if (parameters.length == 3 && $.inArray(parameters[2], spaceUnits) >= 0) {
                                    var id = parameters[0];
                                    var type = parameters[2];
                                    var parsedUrl = window.pixelpoint.utilities.parseUrl(url);
                                    parsedUrl.queryParameters[type] = id;
                                    url = window.pixelpoint.utilities.buildUrl(parsedUrl);
                                    return false;
                                }
                            });
                        } else {
                            var parameters = currentValues.split(":");
                            if (parameters.length == 3 && $.inArray(parameters[2], spaceUnits) >= 0) {
                                var id = parameters[0];
                                var type = parameters[2];
                                var parsedUrl = window.pixelpoint.utilities.parseUrl(url);
                                parsedUrl.queryParameters[type] = id;
                                url = window.pixelpoint.utilities.buildUrl(parsedUrl);
                            }
                        }
                    }
                    return url;
                }
            }

            var ajaxOptions = {
                url: getUrl(),
                delay: defaultDelay,
                dataType: 'json',
                data: function (params) {
                    return {
                        q: params.term,
                        page: params.page
                    };
                },
                processResults: function (data, params) {
                    if (typeof data === "string") {
                        try {
                            data = JSON.parse(data);
                        } catch (error) {
                            console.error("Failed to parse JSON:", error);
                        }
                    }

                    // parse the results into the format expected by Select2
                    // since we are using custom formatting functions we do not need to
                    // alter the remote JSON data, except to indicate that infinite
                    // scrolling can be used
                    params.page = params.page || 1;
                    var limit = data.limit || 30;
                    return {
                        results: _.map(data.items, function (item) {
                            var id = "";

                            if (!!item.children) {
                                var children = _.map(item.children, function (child) {
                                    id = child.id;
                                    if (!!useNameInValue) {
                                        id = child.id + ":" + child.name;
                                    }
                                    if(!!useExternalIdInValue && !!child.external_id){
                                        id += `:${child.external_id}`;
                                    }
                                    if (!!appendToValue && !!child[appendToValue]) {
                                        id += ":" + child[appendToValue];
                                    }
                                    var result = {
                                        id: id,
                                        text: child.name
                                    };
                                    if (!!child.coordinates)
                                        result.coordinates = child.coordinates;
                                    return result;
                                });
                                if (!!item.id) {
                                    id = item.id;
                                    if (!!useNameInValue) {
                                        id = item.id + ":" + item.name;
                                    }
                                    if(!!useExternalIdInValue && !!item.external_id){
                                        id += `:${item.external_id}`;
                                    }
                                    if (!!appendToValue && !!item[appendToValue]) {
                                        id += ":" + item[appendToValue];
                                    }
                                    return {
                                        id: id,
                                        children: children,
                                        text: item.name
                                    };
                                } else {
                                    return {
                                        children: children,
                                        text: item.name
                                    }
                                }
                            }

                            id = item.id;

                            if (!!useNameInValue) {
                                id = item.id + ":" + item.name;
                            }
                            if(!!useExternalIdInValue && !!item.external_id){
                                id += `:${item.external_id}`;
                            }
                            var result = {
                                id: id,
                                text: item.name
                            };
                            if (!!item.coordinates)
                                result.coordinates = item.coordinates;
                            return result;
                        }),
                        pagination: {
                            more: (params.page * limit) < data.total_count
                        }
                    };
                }
            }

            if (useCustomTransportFunction) {
                var customTransport = window.ppComponents.select2.customTransportFunctions[customTransportFunction] || null;
                if (!!customTransport)
                    ajaxOptions.transport = customTransport;
            }

            var closeOnSelect = true;

            if($this.data('close-on-select') == 'disabled' ){
                closeOnSelect = false;
            }

            $this.select2({
                minimumInputLength: 0,
                closeOnSelect: closeOnSelect,
                ajax: ajaxOptions, 
                dropdownCssClass: cssClass,
                containerCssClass: containerCssClass,
                language:lang
            });

            if(!!containerCssClass){
                $this.on("select2:open", () => {
                    addCssContainerClass($this);
                });
            }

            if ($this.find("option:selected").length > 0) {
                var values = [];
                $this.find("option:selected").each(function () {
                    values.push($(this).val());
                });
                values = _.uniq(values);
                if (values.length == 1) {
                    $this.val(values[0]).trigger("change");
                    $this.val(values).trigger("change");
                } else if (values.length > 1) {
                    $this.val(values).trigger("change");
                    $this.val(values).trigger("change");
                }
            }

            if(isLocationTree && $this.is('[multiple]')) {
                var select2Dom = $this.parent().find(".select2-selection__rendered");
                if (select2Dom.length > 0 && $("[data-soft-search]").data("soft-search") == 1) {
                    select2Dom.on("click", ".select2-selection__choice__remove", function () {
                        if(select2Dom.find(".select2-selection__choice").length == 1){
                            $(".brandenbutton.search-button").data("ignore-bbox","1").attr("data-ignore-bbox","1");
                            var valuesToRestore = $this.data("restore");
                            if(!!valuesToRestore){
                                $this.val(valuesToRestore);
                            }
                        }
                    });
                }
            }

            var exposedFunctions = {
                set(data) {
                    if (!data)
                        return;
                    var html = '';
                    if (data instanceof Array) {
                        $.each(data, function (index, element) {
                            html += `<option selected value=${element.id}>${element.text}</option>`;
                        });
                    } else {
                        html = `<option selected value=${data.id}>${data.text}</option>`;
                    }
                    $this.html(html);
                    $this.select2('data', data);
                },
                get() {
                    var data = $this.select2('data');
                    var result = null;
                    if (data instanceof Array) {
                        result = _.map(data, function (element) {
                            return {
                                id: element.id,
                                text: element.text
                            };
                        });
                        result = _.filter(result, function (r) {
                            return r.id != '';
                        });
                    } else {
                        if (data.id != '') {
                            result = {
                                id: data.id,
                                text: data.text
                            };
                            if (asArray) {
                                result = [result];
                            }
                        }
                    }

                    return result;
                }
            };

            if (!!alternativeUrl && !!useAlternativeWhenNotIn && !useAlternative) {
                $this.on('change', function (evt) {
                    var selected = exposedFunctions.get();
                    useAlternative = true;
                    $.each(selected, function (index, value) {
                        if (value.id == useAlternativeWhenNotIn) {
                            useAlternative = false;
                        }
                    });
                });
            }

            $this.data("form-element-functions", exposedFunctions);
        });
    };

    $(window).on("orientationchange", function () {
        $("select.autocomplete.select2-hidden-accessible").each(function () {
            var self = $(this);
            self.select2("destroy");
            setTimeout(function () {
                window.ppComponents.select2.initializeRemote(self);
            }, 50);
        });
    });

    window.ppComponents.select2.initializeRemote($("select.autocomplete"));
});